import React, { memo } from 'react';
import classnames from "classnames";
import { Button } from '../../apps/Cards/components/Button';
import { ArrowLeftSmallIcon } from '../../apps/Cards/icons/ArrowLeftSmall';
import { ArrowRightSmallIcon } from '../../apps/Cards/icons/ArrowRightSmall';
import './SectionHead.scss';
import BrowserLink from '../BrowserLink';
import AppLink from '../AppLink';

export const SectionHead = memo(function SectionHead({ title, titleUppercase = false, count, action, ...props }) {
  return (
    <div className="SectionHead" {...props}>
      <div>
        {title && (
          <h2 className={classnames('SectionHead__title', { 'SectionHead__title_uppercase': titleUppercase })}>{title}</h2>
        )}
        {count && (
          <span className="SectionHead__count">{count}</span>
        )}
      </div>

      {action && (
        <div>
          {action.type === 'button' && (
            <Button
              className="SectionHead__btn"
              type="link"
              onClick={action.onClick}
            >
              <span>
                {action.arrow === 'left' && <span className="anticon"><ArrowLeftSmallIcon /></span>}
                {action.children}
                {action.arrow === 'right' && <span className="anticon"><ArrowRightSmallIcon /></span>}
              </span>
            </Button>
          )}

          {action.type === 'link' && (
            action.route ? (
              <AppLink to={action.route} className="SectionHead__link" onClick={(e) => {
                // actid=4
                window.analytics?.track("button:click", {
                  "button_name": "Show more",
                  "parent_object_title": title,
                  "title": "Show more",
                  "url": action.route
                });
              }}>{action.children}</AppLink>
            ) : (
              <BrowserLink href={action.url} className="SectionHead__link" onClick={(e) => {
                // actid=3
                window.analytics?.track("button:click", {
                  "button_name": "Upcoming Events",
                  "parent_object_title": title,
                  "title": "Upcoming Events",
                  "url": action.url
                });

              }}>{action.children}</BrowserLink>
            )
          )}
        </div>
      )}
    </div>
  );
});